import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "os-line.diagonal",
  "use": "os-line.diagonal-usage",
  "viewBox": "0 0 15.771 15.791",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.771 15.791\" id=\"os-line.diagonal\"><path d=\"M.313 13.935Q0 14.248 0 14.702t.313.777q.322.312.771.312.45 0 .771-.313L15.46 1.866q.313-.322.313-.771 0-.45-.313-.762t-.767-.317q-.454-.005-.766.317z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol